import React from 'react';
import './Header.scss';
import { AppWrap } from '../../wrapper';
import { easeInOut, motion } from 'framer-motion';
import { images } from '../../constants'

export const Header = () => {

  const scaleVariants ={
    whileInView:{
      scale: [0, 1],
      opacity: [0, 1],
      transition:{
        duration: 1,
        ease: 'easeInOut'
      }
    }
  }

  return (
    <div id="home" className='app__header app__flex'>
      <motion.div whileInView={{ x: [-100, 0], opacity: [0, 1]}} transition={{ duration: 0.9}} className="app__header-info">
        <div className='app__header-badge'>
          <div className='badge-cmp app__flex'>
            <span>👋🏾</span>
            <div style={{ marginLeft: 20}}>
              <p className='p-text'>Hi there, I am</p>
              <h1 className='head-text'>Saad{/* Sai El Haq */}</h1>
            </div>
          </div>
          <div className='tag-cmp app__flex'>
            <p className='p-text'>Web Creative Designer</p>
            <p className='p-text'>Fullstack Developer</p>
          </div>
        </div>
      </motion.div>
      <motion.div whileInView={{ opacity: [0, 1]}} transition={{ duration: 0.9, delayChildren: 0.9}} className="app__header-img">
        <img src={images.profile} alt="profile-bg" />
        <motion.img whileInView={{ scale: [0, 1]}} transition={{ duration: 1.4, ease: 'easeInOut'}} src={images.circle} alt="profile_circle" className="overlay_circle" />
      </motion.div>


      <motion.div variants={scaleVariants} whileInView={scaleVariants.whileInView} className="app__header-circles">
        {[images.vite, images.next, images.sass].map((circle, index) => (
          <div className='circle-cmp app__flex' key={`circle-${index}`}>
            <img src={circle} alt="circle" />
          </div>
        ))}
      </motion.div>
    </div>
  )
}

export default AppWrap(Header, 'home');